import { toCamelCase } from 'case-converter';
import { AvailableRoom, StaticRoom } from '@features/rooms/types';
import { byPriorityThenPrice } from '@features/rooms/helpers/byPriorityThenPrice.helper';
import { RoomSchema } from './schemas';
import { Room } from './types';

type MapToRooms = (
  staticRooms: StaticRoom[],
  availableRooms: AvailableRoom[],
  requestedQuantity: number
) => Room[];

export const toRoomsByAvailability: MapToRooms = (
  staticRooms,
  availableRooms,
  requestedQuantity
) => {
  const rooms = staticRooms
    .map((room) => {
      const availableRoom = availableRooms.find(({ id }) => id === room.room_id);
      const result = RoomSchema.safeParse({
        id: room.room_id,
        title: room.title,
        imageUrl: room.image_url ?? '',
        price: availableRoom
          ? {
              currencyCode: availableRoom.price_per_stay?.currency_code,
              amount:
                availableRoom.discount?.standard_price.amount ??
                availableRoom.price_per_stay?.amount,
            }
          : undefined,
        quantity: availableRoom?.quantity,
        displayUrgencyMessaging:
          availableRoom?.display_urgency_messaging ||
          (availableRoom && availableRoom?.quantity < requestedQuantity),
        maxOccupancy: room.max_occupancy,
        maxAdults: room.max_adults,
        maxChildren: room.max_children,
        priority: room.priority ?? null,
        unAvailable: !availableRoom || availableRoom.quantity < requestedQuantity,
        discount: availableRoom?.discount ? toCamelCase(availableRoom.discount) : undefined,
      });
      if (result.success) {
        return result.data;
      }
    })
    .filter((item): item is Room => !!item)
    // Unavailable rooms always sort last so the user sees bookable rooms first,
    // then priority/price ordering applies within the available and unavailable groups.
    .sort((a, b) => {
      if (a.unAvailable !== b.unAvailable) {
        return a.unAvailable ? 1 : -1;
      }
      return byPriorityThenPrice(a, b);
    });

  return rooms;
};
